import dynamic from 'next/dynamic'

export const DynamicSnapEBTMembershipEntryModal = dynamic(
  () => import('.').then((mod) => mod.SnapEBTMembershipEntryModal),
  { ssr: false },
)
